import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, ReactDOM, pluralize} from '@api'
import {Dialog, Button} from '@material-ui/core'
import {LargeButton, useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance, icons} from '@stores'
import * as css from './FilesToPasteIntoCatalogDialog.css'

/// region Store

export class FilesToPasteIntoCatalogDialogStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @action onCancel = () => {
    this.lastFiles = this.catalog.filesToMaybePaste
    this.catalog.filesToMaybePaste = null
  }

  @action onCreateOneItem = async () => {
    const {catalog, catalog: {createItem, filesToMaybePaste}} = this
    this.lastFiles = filesToMaybePaste
    catalog.filesToMaybePaste = null

    const offlineItem = await createItem.createOfflineItem()
    catalog.focusedCatalogItemId = offlineItem.item.data._id
    await catalog.onPasteImages(filesToMaybePaste)
  }

  @action onCreateManyItems = async () => {
    const {catalog, catalog: {createItem, filesToMaybePaste}} = this
    this.lastFiles = filesToMaybePaste
    catalog.filesToMaybePaste = null

    for (const file of filesToMaybePaste) {
      const offlineItem = await createItem.createOfflineItem()
      catalog.focusedCatalogItemId = offlineItem.item.data._id
      await catalog.onPasteImages([file])
    }
  }

  @observable.ref lastFiles: Array<File>

  @computed get count() {
    const {catalog: {filesToMaybePaste}, lastFiles} = this
    return filesToMaybePaste?.length ?? lastFiles?.length ?? 0
  }
}

export const FilesToPasteIntoCatalogDialogStoreContext = React.createContext<FilesToPasteIntoCatalogDialogStore>(null)
export const useFilesToPasteIntoCatalogDialogStore = () => React.useContext(FilesToPasteIntoCatalogDialogStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const FilesToPasteIntoCatalogDialog = observer<MyProps>(function FilesToPasteIntoCatalogDialog({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new FilesToPasteIntoCatalogDialogStore(stores, obsProps)),
    {count, catalog: {filesToMaybePaste, catalogItemName}, onCancel, onCreateOneItem, onCreateManyItems} = store

  useEffect(() => store.registerEffects(), [])

  return ReactDOM.createPortal(
    <Dialog
      open={!_.isEmpty(filesToMaybePaste)}
      onClose={onCancel}
      className={css.root}
      classes={{
        paper: css.paper
      }}
    >
      {/*<DialogContent className={css.dialogContent}>*/}
      {/*  <DialogContentText className={css.contextText}>*/}
      {/*     There are {filesToMaybePaste.length} Images on your clipboard.*/}
      {/*   </DialogContentText>*/}
      {/*</DialogContent>*/}
      <div className={css.contents}>
        <div className={css.header}>{`Create ${catalogItemName}`}</div>
        <div className={css.detail}>{`${count} images have been copied to your clipboard.`}</div>
        <div className={css.buttons}>
          <LargeButton icon={icons.add} title={`Create one ${catalogItemName}`} subtitle={`(${count} images)`} onClick={onCreateOneItem}/>
          <LargeButton icon={icons.addMany} title={`Create ${pluralize(catalogItemName)}`} subtitle={`(from ${count} images)`} onClick={onCreateManyItems}/>
          <div className={css.footer}>
            <Button onClick={onCancel} variant='text' color={'secondary'} size={'small'}>Cancel</Button>
          </div>
        </div>
      </div>
    </Dialog>
    , document.body)
})
/// endregion




// WEBPACK FOOTER //
// ./src/modules/catalog/FilesToPasteIntoCatalogDialog.tsx